import { useI18n } from '../i18n/context.js'
import type { VersionConflictInfo } from '../domain/conflict.js'
import { Dialog } from '../ui/overlays.js'
import { Button } from '../ui/primitives.js'

interface ConflictDialogProps {
  conflict: VersionConflictInfo
  onKeepMine: () => void
  onKeepTheirs: () => void
  onDismiss: () => void
  busy?: boolean
  title?: string
  message?: string
}

/**
 * The 409 screen: nothing typed is lost. The person sees that someone else
 * changed the document, and picks one of the two honest options — retry
 * their own edit against the real version, or drop it and reload what is
 * actually on the server.
 */
export function ConflictDialog({ conflict, onKeepMine, onKeepTheirs, onDismiss, busy, title, message }: ConflictDialogProps) {
  const { t } = useI18n()
  return <Dialog
    title={title ?? t('conflict.title')}
    icon="swap_horiz"
    onClose={onDismiss}
    dismissible={!busy}
    actions={<>
      <Button variant="text" onClick={onKeepTheirs} disabled={busy}>{t('conflict.keepTheirs')}</Button>
      <Button variant="filled" onClick={onKeepMine} disabled={busy} data-autofocus>{t('conflict.keepMine')}</Button>
    </>}
  >
    <p className="dialog-message">{message ?? t('conflict.description', { expectedVersion: conflict.expectedVersion, actualVersion: conflict.actualVersion })}</p>
  </Dialog>
}
